import { ContactType } from "../shared/enums/ContactType";

export class Emergency {
    type: ContactType = 0; // quem é o contato
    name: String;
    phone: String;

    loadToEdit(r: any) {
        this.type = r.type;
        this.name = r.name;
        this.phone = r.phone;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Emergency.model.ts